import { useEffect } from 'react';

import { useContextCurrency, useContextUser, useContextUtil } from '@core/context';
import { useLanguage } from '@core/hook';
import { EGTMEventName, GTMDataLayer } from '@core/type';
import { ProductPageEntity } from '@core/type/api';
import { roundPrice } from '@core/util';

import { useContextGTM } from '../context-gtm';
import { getEcommerceItemProps, getEventOriginUrl, pushGTMEvent } from '../helpers';

export const useEventViewItem = (product: ProductPageEntity) => {
  const { currency } = useContextCurrency();
  const { currency: userCurrency } = useContextUser();
  const { enable, baseDatalayerProps } = useContextGTM();
  const { isScriptGALoaded } = useContextUtil();
  const { language } = useLanguage();

  const currencySent = userCurrency || currency;

  useEffect(() => {
    if (enable && isScriptGALoaded) {
      const priceWithoutVat = roundPrice(product?.totalPrice - product?.vatPrice);
      const data: GTMDataLayer = {
        ...baseDatalayerProps,
        eventOrigin: getEventOriginUrl(baseDatalayerProps),
        event: EGTMEventName.VIEW_ITEM,
        ecommerce: {
          value: priceWithoutVat,
          currency: currencySent,
          items: [
            {
              ...getEcommerceItemProps({
                ...product,
                totalPrice: priceWithoutVat,
                quantity: 1,
              }),
            },
          ],
        },
      };

      pushGTMEvent(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScriptGALoaded, currencySent, product?.slug, language]);
};
